import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  Row,
  Col,
  Typography,
  Button,
  Select,
  Icon,
  DatePicker,
  Input,
  Divider,
  Upload,
  Modal,
  Checkbox,
} from "antd";
import ClaimAndInjury from "components/ClaimAndInjury/index";
import TextAreaBox from "components/TextAreaBox";
import InputBox from "components/InputBox";
import InlineContact from "components/InlineContact";
import TagsInputBox from "components/TagsInputBox";
import InputCurrencyBox from "components/InputCurrencyBox";
import SpinBox from "components/SpinBox";
import { BackIcon } from "components/Icons";
import { getBase64 } from "utils/utils";
import { updateReportInfo } from "redux/report";
import * as API from "utils/api";
import * as Utils from "utils/utils";
import dynamicData from "dynamicData";
import * as Logic from "../ProposedMedicare/logic";
import ClaimantInfo from "components/ClaimantInfoOnWizard";
import "./Demographic.scss";
import RichTextEditor from "../../../../components/RichTextEditor/RichTextEditor";

const { Title, Text } = Typography;
const { Option } = Select;

const beforeUpload = (file) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    Modal.error({ content: "You can only upload JPG/PNG file!" });
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    Modal.error({ content: "Image must smaller than 2MB!" });
  }
  return isJpgOrPng && isLt2M;
};

class Demographic extends Component {
  constructor(props) {
    super(props);

    let report_id = "";
    if (this.props.location && this.props.location.state) {
      report_id = this.props.location.state.data.report_id;
    }

    this.state = {
      report_id: report_id,
      contactsList: [],
      icdCodeList: [],
      juridictionStateList: [],
      plaintiff_attorney: undefined,
      defense_attorney: undefined,
      insurance_carrier: undefined,
      employer_demographics: undefined,
      report_claim_id: "",
      body_parts: "",
      show_additional_comments: false,
      additional_comments: "",
      related_diagnosis: [],
      referral_date: moment(),
      date_of_report: moment(),
      signature: "",
      imageUrl: "",
      juridiction_state_id: undefined,
      date_of_injury: moment(),
      icd_code: "",
      icd_descr: "",
      newIcdCodeList: [],
      isModalOpen: false,
      medicareInfo: {},
      loading: false,
      loadingTitle: "Loading...",
      report_contacts: [],
      plaintifList: [],
      defenseList: [],
      insuranceList: [],
      employerList: [],
      medicare: [],
    };
    this.timeoutId = setInterval(
      this.handleUpdateReport,
      this.props.autoSavingTime
    );
  }
  componentWillUnmount = () => {
    clearInterval(this.timeoutId);
  };
  componentDidMount() {
    const { report_id, newIcdCodeList } = this.state;

    this.setState({ loading: true });
    API.getContactsData("", 0, 1000) //Getting all contacts data
      .then((res) => {
        const dynamic = dynamicData();
        this.setState({
          contactsList: res.contacts,
          plaintifList: res.contacts.filter((item) => {
            return (
              (item.contact_type ? item.contact_type.name : "") ==
              dynamic.plaintiff_attorney
            );
          }),
          defenseList: res.contacts.filter(
            (item) =>
              (item.contact_type ? item.contact_type.name : "") ==
              dynamic.defense_attorney
          ),
          insuranceList: res.contacts.filter(
            (item) =>
              (item.contact_type ? item.contact_type.name : "") ==
              dynamic.insurance_carrier
          ),
          employerList: res.contacts.filter(
            (item) =>
              (item.contact_type ? item.contact_type.name : "") ==
              dynamic.employer_demographics
          ),
        });
      });
    API.getIcdCodeData("").then((res) => {
      this.setState(
        {
          icdCodeList: res.icd_codes,
        },
        () => {}
      );
    });
    API.getJuridictionStateList().then((res) => {
      this.setState({
        juridictionStateList: res.juridictionStates,
      });
    });
    API.getMedicareData(report_id).then((res) => {
      this.setState({
        loading: false,
        medicare: res.medicare_cost_projections,
      });
    });
    API.getReportContacts(report_id).then((res) => {
      this.setState({ report_contacts: res.report_contacts.rows });
    });
    API.getReportById(report_id).then((res) => {
      const reportInfo = res.report;
      this.props.updateReportInfo(reportInfo);
      let related_diagnosis = [];
      // related_diagnosis =
      let newIcdCodeList = [];
      if (reportInfo.related_diagnosis && reportInfo.related_diagnosis !== "") {
        related_diagnosis = reportInfo.related_diagnosis.split(",");
        newIcdCodeList = related_diagnosis.map((item) => {
          return {
            ...JSON.parse(item.split("<").join(",").split("$").join(",")),
            // med_descr: "",
          };
        });
      }

      // .split(",")
      // .map((item) => {

      //   return JSON.parse(item.replace(/|/g, ","));
      // });
      this.setState({
        oldDiagnosis: reportInfo.related_diagnosis,
        plaintiff_attorney: reportInfo.plaintiff_attorney || undefined,
        defense_attorney: reportInfo.defense_attorney || undefined,
        insurance_carrier: reportInfo.insurance_carrier || undefined,
        report_claim_id: reportInfo.report_claim_id || "",
        employer_demographics: reportInfo.employer_demographics || undefined,
        body_parts: reportInfo.body_parts,
        newIcdCodeList: newIcdCodeList,
        show_additional_comments: reportInfo.show_additional_comments,
        additional_comments: reportInfo.additional_comments,
        related_diagnosis,
        referral_date: reportInfo.referral_date
          ? moment(reportInfo.referral_date)
          : moment(),
        date_of_report: reportInfo.date_of_report
          ? moment(reportInfo.date_of_report)
          : moment(),
        signature: reportInfo.is_signature_photo ? "" : reportInfo.signature,
        imageUrl: reportInfo.is_signature_photo ? reportInfo.signature : "",
        juridiction_state_id: reportInfo.juridiction_state_id || undefined,
        date_of_injury: reportInfo.date_of_injury
          ? moment(reportInfo.date_of_injury)
          : moment(),
        loading: false,
      });
    });
  }
  getReportContacts = async () => {
    const { report_id } = this.state;
    let res = await API.getReportContacts(report_id);
    this.setState({ report_contacts: res.report_contacts.rows });
  };
  handlePhotoChange = (info) => {
    // if (info.file.status === 'uploading') {
    //   this.setState({ loading: true });
    // })
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  handleOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleAddNewICDCode = () => {
    const {
      icd_code,
      icd_descr,
      newIcdCodeList,
      related_diagnosis,
    } = this.state;
    const newItem = { code: icd_code, med_descr: icd_descr };
    if (icd_code === "" || icd_descr === "") {
      Modal.error({
        content: "Please input the values",
      });
      return;
    }

    newItem.med_descr = newItem.med_descr.split(",").join("$");
    newIcdCodeList.push(newItem);
    related_diagnosis.push(JSON.stringify(newItem).split(",").join("<"));

    this.setState({ isModalOpen: false, icd_code: "", icd_descr: "" });
  };

  handleUpdateReport = (isNextStep = false) => {
    const {
      report_id,
      plaintiff_attorney,
      defense_attorney,
      insurance_carrier,
      report_claim_id,
      employer_demographics,
      body_parts,
      show_additional_comments,
      additional_comments,
      related_diagnosis,
      referral_date,
      date_of_report,
      signature,
      imageUrl,
      juridiction_state_id,
      date_of_injury,
      newIcdCodeList,
    } = this.state;

    const new_related_diagnosis = [];
    related_diagnosis.forEach((value) => {
      let item = newIcdCodeList.find((ele) => value === ele.code);
      if (item) {
        new_related_diagnosis.push(JSON.stringify(item).replace(/,/g, "|"));
      } else {
        new_related_diagnosis.push(value);
      }
    });

    const params = {
      id: report_id,
      plaintiff_attorney,
      defense_attorney,
      insurance_carrier,
      report_claim_id,
      employer_demographics,
      body_parts,
      show_additional_comments,
      additional_comments,
      related_diagnosis: new_related_diagnosis.toString(),
      referral_date: moment(referral_date).format("MM/DD/YYYY"),
      date_of_report: moment(date_of_report).format("MM/DD/YYYY"),
      signature: imageUrl ? imageUrl : signature,
      is_signature_photo: imageUrl ? true : false,
      juridiction_state_id,
      date_of_injury: moment(date_of_injury).format("MM/DD/YYYY"),
    };

    if (isNextStep) {
      this.setState({
        loading: true,
        loadingTitle: "Saving...",
      });

      API.updateReport(params).then((res) => {
        this.setState({ loading: false });
        clearTimeout(this.timeoutId);
        this.props.updateReportInfo(res.report);
        this.props.history.push("/app/reports/msa/medicalContent", {
          data: { report_id: report_id },
        });
      });
    } else {
      API.updateReport(params).then((res) => {
        this.props.updateReportInfo(res.report);
      });
    }
  };
  componentDidUpdate() {}
  handleSearchIcdCodes = (value) => {
    API.getIcdCodeData(value).then((res) => {
      let correctArr = [...res.icd_codes];
      this.setState({
        icdCodeList: correctArr,
      });
    });
  };
  render() {
    let dataDynamic = { ...dynamicData() };

    const {
      contactsList,
      icdCodeList,
      newIcdCodeList,
      juridictionStateList,
      plaintiff_attorney,
      defense_attorney,
      insurance_carrier,
      report_claim_id,
      employer_demographics,
      body_parts,
      show_additional_comments,
      additional_comments,
      related_diagnosis,
      referral_date,
      date_of_report,
      signature,
      imageUrl,
      juridiction_state_id,
      date_of_injury,
      icd_code,
      icd_descr,
      isModalOpen,
      medicareInfo,
      loading,
      loadingTitle,
      plaintifList,
      defenseList,
      insuranceList,
      employerList,
    } = this.state;
    return (
      <Row className="msa-demographic-container">
        <Row type="flex" align="middle" className="header">
          <Col className="title">
            <Title level={4} className="title-text">
              Setup MSA Report
            </Title>
          </Col>
          <Col className="back" onClick={() => this.props.history.goBack()}>
            <BackIcon className="icon" />
            <Text>Cancel</Text>
          </Col>
          <Col className="step">
            <Text>Step 1 of 17</Text>
          </Col>
        </Row>
        <Row className="main">
          <SpinBox loading={loading} title={loadingTitle}>
            <Row className="content">
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={24}>
                  <ClaimantInfo
                    claimant={{
                      ...this.props.reportInfo.claimant,
                      report_claim_id,
                    }}
                  />
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={24}>
                  <Text className="title">Demographic Information </Text>
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={11}>
                  <InlineContact
                    getReportContacts={this.getReportContacts}
                    contact_type_id={dataDynamic.plaintiff_attorney_id}
                    another={false}
                    label="Plaintiff Attorney"
                    report_id={this.state.report_id}
                    contactsList={plaintifList}
                    type={"plaintiff_attorney"}
                    value={this.state.report_contacts
                      .filter((item) => item.type === "plaintiff_attorney")
                      .map((item) => {
                        if (!item.contact) {
                          return null;
                        }
                        return item.contact.id;
                      })
                      .filter((x) => x)}
                  />
                </Col>
                <Col md={11}>
                  <InlineContact
                    getReportContacts={this.getReportContacts}
                    contact_type_id={dataDynamic.defense_attorney_id}
                    another={false}
                    label="Defense Attorney"
                    report_id={this.state.report_id}
                    contactsList={defenseList}
                    type={"defense_attorney"}
                    value={this.state.report_contacts
                      .filter((item) => item.type === "defense_attorney")
                      .map((item) => item.contact.id)}
                  />
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={11}>
                  <InlineContact
                    getReportContacts={this.getReportContacts}
                    another={false}
                    contact_type_id={dataDynamic.insurance_carrier_id}
                    label="Insurance Carrier"
                    report_id={this.state.report_id}
                    contactsList={insuranceList}
                    type={"insurance_carrier"}
                    value={this.state.report_contacts
                      .filter((item) => item.type === "insurance_carrier")
                      .map((item) => item.contact.id)}
                  />
                </Col>
                <Col style={{ marginTop: -52 }} md={11}>
                  <Row>
                    <Text>State of Jurisdiction</Text>
                  </Row>
                  <Row>
                    <Select
                      showSearch
                      placeholder="Please select"
                      optionFilterProp="children"
                      className="dropdown"
                      value={juridiction_state_id}
                      onChange={(value) =>
                        this.setState({ juridiction_state_id: value })
                      }
                      suffixIcon={
                        <Icon
                          type="caret-down"
                          style={{ color: "black" }}
                          theme="filled"
                        />
                      }
                    >
                      {juridictionStateList.map((item) => (
                        <Option value={item.id} key={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Row>
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={11}>
                  <InlineContact
                    getReportContacts={this.getReportContacts}
                    contact_type_id={dataDynamic.employer_demographics_id}
                    another={false}
                    label="Employer Demographics"
                    report_id={this.state.report_id}
                    contactsList={employerList}
                    type={"employer_demographics"}
                    value={this.state.report_contacts
                      .filter((item) => item.type === "employer_demographics")
                      .map((item) => item.contact.id)}
                  />
                </Col>
              </Row>
              <ClaimAndInjury
                onChange={(value) => this.setState({ report_claim_id: value })}
                report_claim_id={report_claim_id}
              />
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={24}>
                  <TagsInputBox
                    label="Body Parts Accepted by Claims"
                    placeholder="Please enter"
                    value={body_parts}
                    onChange={(value) => this.setState({ body_parts: value })}
                  />
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={24}>
                  <RichTextEditor
                    label="Additional Comments"
                    placeholder="Please enter"
                    value={additional_comments}
                    onChange={(value) =>
                      this.setState({ additional_comments: value })
                    }
                  />
                  {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      marginTop: 10,
                    }}
                  >
                    <Checkbox
                      checked={show_additional_comments}
                      onChange={(value) => {
                        this.setState({
                          show_additional_comments: !show_additional_comments,
                        });
                      }}
                    >
                      Show Additional comments in the pdf
                    </Checkbox>
                  </div> */}
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={24}>
                  <Row className="label">
                    <Text>Related Diagnosis</Text>
                  </Row>
                  <Row>
                    <Select
                      mode="multiple"
                      className="dropdown"
                      filterOption={false}
                      // optionFilterProp="filter"
                      placeholder="Please enter"
                      value={related_diagnosis}
                      onSearch={(value) => {
                        if (value) {
                          this.handleSearchIcdCodes(value);
                        }
                      }}
                      onChange={(value) => {
                        this.setState({ related_diagnosis: value });
                      }}
                    >
                      {icdCodeList.map((item, index) => {
                        let value = JSON.stringify({
                          code: item.code,
                          med_descr: item.med_descr
                            ? item.med_descr.replace(/,/g, "$")
                            : "",
                        }).replace(/,/g, "<");

                        return (
                          <Option
                            key={index}
                            //  filter={item.code.concat("_" + item.med_descr)}
                            value={value}
                          >
                            {`${item.med_descr} (${item.code})`}
                          </Option>
                        );
                      })}
                      {newIcdCodeList.map((item, index) => {
                        let value = JSON.stringify({
                          code: item.code,
                          med_descr: item.med_descr.replace(/,/g, "$"),
                        }).replace(/,/g, "<");
                        return (
                          <Option
                            key={index}
                            filter={item.code.concat("_" + item.med_descr)}
                            value={value}
                          >
                            {item.med_descr}
                          </Option>
                        );
                      })}
                    </Select>
                  </Row>
                  <Row>
                    <Button
                      type="primary"
                      className="green-btn add-icd-code_button"
                      onClick={this.handleOpenModal}
                    >
                      Add Custom Code
                    </Button>
                  </Row>
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={24}>
                  <InputCurrencyBox
                    label="MSA Allocation Amount"
                    placeholder=" "
                    disabled={true}
                    value={
                      Logic.anticipated_medicare_cost(
                        this.state.medicare
                      ).toFixed(2) || 0
                    }
                  />
                </Col>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                <Col md={11}>
                  <Row className="label">
                    <Text>Referral Date</Text>
                  </Row>
                  <Row>
                    <DatePicker
                      className="date"
                      format="MM/DD/YYYY"
                      value={referral_date}
                      onChange={(date, dateString) =>
                        this.setState({ referral_date: date })
                      }
                    />
                  </Row>
                </Col>
                <Col md={11}>
                  <Row className="label">
                    <Text>Date of Report</Text>
                  </Row>
                  <Row>
                    <DatePicker
                      className="date"
                      format="MM/DD/YYYY"
                      value={date_of_report}
                      onChange={(date, dateString) =>
                        this.setState({ date_of_report: date })
                      }
                    />
                  </Row>
                </Col>
              </Row>
              <Row className="row">
                <Row className="label">
                  <Text>Signature</Text>
                </Row>
                <Row type="flex" justify="space-between" align="middle">
                  <Col md={11}>
                    <Input
                      placeholder="Your Name"
                      className="input"
                      value={signature}
                      onChange={(e) =>
                        this.setState({ signature: e.target.value })
                      }
                    />
                  </Col>
                  <Col md={1} style={{ textAlign: "center" }}>
                    <Text>or</Text>
                  </Col>
                  <Col md={11}>
                    <Row
                      type="flex"
                      justify="center"
                      align="middle"
                      className="upload"
                    >
                      <Upload
                        name="logo"
                        listType="text"
                        className="logo-uploader"
                        showUploadList={false}
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        beforeUpload={beforeUpload}
                        onChange={this.handlePhotoChange}
                        ref={(node) => {
                          this.upload_btn = node;
                        }}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="signature"
                            className="signature-image"
                          />
                        ) : (
                          <Text className="logo-button">
                            Upload a picture of signature
                          </Text>
                        )}
                      </Upload>
                    </Row>
                  </Col>
                </Row>
              </Row>
              <Row
                type="flex"
                justify="space-between"
                align="middle"
                className="row"
              >
                {/* <Col md={11}>
                  <Row className="label">
                    <Text>Injury Date</Text>
                  </Row>
                  <Row>
                    <DatePicker
                      className="date"
                      format="MM/DD/YYYY"
                      value={date_of_injury}
                      onChange={(date, dateString) =>
                        this.setState({ date_of_injury: date })
                      }
                    />
                  </Row>
                </Col> */}
              </Row>
              <Divider className="divider" />
              <Row
                type="flex"
                justify="center"
                align="middle"
                className="confirm-button"
              >
                <Button
                  type="primary"
                  size="large"
                  className="green-btn button"
                  onClick={() => this.handleUpdateReport(true)}
                >
                  Next Step
                </Button>
              </Row>
            </Row>
          </SpinBox>
        </Row>
        <Modal
          visible={isModalOpen}
          onCancel={this.handleCloseModal}
          footer={null}
          centered={true}
          closable={true}
          width={500}
          className="add-icd-code-modal"
          title={"Add Custom Code"}
        >
          <Row className="modal-body">
            <Row type="flex" justify="start" align="middle" className="row">
              <Col className="label">
                <Text className="label">Code</Text>
              </Col>
              <Col className="input-col">
                <Input
                  placeholder={"Required"}
                  className="input"
                  disabled={false}
                  value={icd_code}
                  onChange={(e) => this.setState({ icd_code: e.target.value })}
                />
              </Col>
            </Row>
            <Row type="flex" justify="start" align="middle" className="row">
              <Col className="label">
                <Text className="label">Description</Text>
              </Col>
              <Col className="input-col">
                <Input
                  placeholder={"Required"}
                  className="input"
                  disabled={false}
                  value={icd_descr}
                  onChange={(e) => this.setState({ icd_descr: e.target.value })}
                />
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Button
                type="primary"
                className="green-btn button"
                onClick={this.handleAddNewICDCode}
              >
                ADD
              </Button>
            </Row>
          </Row>
        </Modal>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const props = {
    autoSavingTime: state.report.autoSavingTime,
    reportInfo: state.report.reportInfo,
  };
  return props;
};

export default connect(mapStateToProps, { updateReportInfo })(Demographic);
